import { useTranslation } from "react-i18next";

const BillingInformation = ({
    authDetailBooking,
    typo12,
}) => {
    const { t, i18n } = useTranslation();

    const billingInformation = authDetailBooking?.user?.[authDetailBooking?.user?.role + "Detail"]?.billingInformation;
    billingInformation.email = authDetailBooking?.user?.email

    return (
        <div className="tw:rounded-[5px] tw:border tw:border-[#e8e8e8] tw:bg-white tw:lg:px-7 tw:py-[30px]">
            <div className="tw:font-hanken-grotesk tw:pb-6 tw:text-[15px] tw:font-bold tw:leading-[22px] tw:text-[#282828] tw:px-5 tw:lg:px-0">
                {t("bookingDetail.billingInformation.title")}
            </div>
            <div className="tw:h-px tw:w-full tw:bg-[#e8e8e8]" />
            <div className="tw:flex tw:flex-col tw:gap-5 tw:pt-6 tw:px-5 tw:lg:px-0">
                <div className="tw:flex tw:flex-wrap">
                    <div className="tw:flex tw:w-1/2 tw:md:w-1/4 tw:flex-col tw:gap-[3px] tw:pb-4 tw:md:pb-0">
                        <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] ${typo12}`}>{t("bookingDetail.billingInformation.item.reservationHolder")}</span>
                        <p className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828] tw:break-words">
                            {`${billingInformation?.pronounced} ${billingInformation?.name}`}
                        </p>
                    </div>
                    <div className="tw:flex tw:w-1/2 tw:md:w-1/4 tw:flex-col tw:gap-[3px] tw:pb-4 tw:md:pb-0">
                        <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] ${typo12}`}>{t("bookingDetail.billingInformation.item.email")}</span>
                        <p className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828] tw:break-all">
                            {billingInformation?.email}
                        </p>
                    </div>
                    <div className="tw:flex tw:w-1/2 tw:md:w-1/4 tw:flex-col tw:gap-[3px] tw:pb-4 tw:md:pb-0">
                        <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] ${typo12}`}>{t("bookingDetail.billingInformation.item.phoneNumber")}</span>
                        <p className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828] tw:break-words">
                            {`(${billingInformation?.prefix_number}) ${billingInformation?.phone}`}
                        </p>
                    </div>
                    <div className="tw:flex tw:w-1/2 tw:md:w-1/4 tw:flex-col tw:gap-[3px] tw:pb-4 tw:md:pb-0">
                        <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] ${typo12}`}>{t("bookingDetail.billingInformation.item.country")}</span>
                        <p className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828] tw:break-words">
                            {billingInformation?.country}
                        </p>
                    </div>

                </div>
                <div className="tw:flex tw:flex-wrap">
                    <div className="tw:flex tw:w-1/2 tw:md:w-1/4 tw:flex-col tw:gap-[3px] tw:pb-4 tw:md:pb-0">
                        <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] ${typo12}`}>{t("bookingDetail.billingInformation.item.postalCode")}</span>
                        <p className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828] tw:break-words">
                            {billingInformation?.postal_code}
                        </p>
                    </div>
                    {
                        billingInformation?.city && (
                            <div className="tw:flex tw:w-1/2 tw:md:w-1/4 tw:flex-col tw:gap-[3px] tw:pb-4 tw:md:pb-0">
                                <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] ${typo12}`}>{t("bookingDetail.billingInformation.item.city")}</span>
                                <p className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828] tw:break-words">
                                    {billingInformation?.city}
                                </p>
                            </div>
                        )
                    }
                    <div className="tw:flex tw:w-full tw:md:w-1/4 tw:flex-col tw:gap-[3px]">
                        <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] ${typo12}`}>{t("bookingDetail.billingInformation.item.address")}</span>
                        <p className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828] tw:break-words">
                            {billingInformation?.address}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BillingInformation;